import styled from 'styled-components'

import { CenteredP, H2 } from './styles.common'

export const PageTitle = styled.div`
  color: #232323;
  display: flex;
  padding-bottom: 75px;
  flex-direction: column;
  align-items: center;
`

export const Products = styled.div`
  display: flex;
  margin-bottom: 75px;
  & > div:not(:last-child) {
    margin-right: 47px;
  }
`

export const ProductSelectors = styled.div`
  display: flex;
  margin-bottom: 75px;
  & > div:not(:last-child) {
    margin-right: 15px;
  }
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 12px;
`

export const Product = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 370px;
  height: 713px;
  background: #ffffff;
  border-radius: 20px;
  filter: drop-shadow(0px 24px 48px rgba(112, 0, 153, 0.1));
`

export const ProductTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const ImageContainer = styled.div`
  width: 100px;
  height: 100px;
  background: ${({ backgroundColor }) => backgroundColor};
  display: grid;
  place-items: center;
  border-radius: 50%;
  margin-bottom: 32px;
  margin-top: 59px;

  span {
    font-size: 44px;
  }

  @media (max-width: 639px) {
    margin: 40px 0 32px 0;
  }
`

export const Title = styled.p`
  font-family: DM Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 36px;
  text-align: center;
  color: #232323;
`

export const PlusMinusButton = styled.button`
  border: 0px;
  background-color: white;
`

export const QuantityInputBox = styled.input`
  width: 94px;
  height: 42px;
  border: 1px solid #d5d4da;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
`

export const ProductMiddle = styled.span`
  padding-top: 28px;
  height: 240px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 200%;
  text-align: center;
  color: #232323;
`

export const ProductBottom = styled.div`
  flex-direction: column;
  justify-content: flex-end;
  margin: 0 auto;
`

export const ProductPricingInfoContainer = styled.div`
  height: 90px;
`

export const Divider = styled.span`
  width: 100%;
  height: 1px;
  background: rgba(213, 212, 218, 0.5);
`

export const ProductButton = styled(CenteredP)`
  padding: 10px;
`

export const ProductButtonSelected = styled(ProductButton)`
  background: rgba(213, 212, 218, 0.5);
  border-radius: 4px;
`

export const ProductButtonUnselected = styled(ProductButton)`
  color: #646f7b;
`

export const PricingTierTitle = styled(H2)`
  margin-top: 0;
`
